import { produce } from 'immer';
import React, { FC } from 'react';
import { useDispatch } from 'react-redux';

import { Archive } from 'src/presentation/components/pages/shared/rowActions/Archive';
import { Edit } from 'src/presentation/components/pages/shared/rowActions/Edit';
import { CustomAttribute } from 'src/actions/customAttributes/customAttribute';
import customAttributesResource from 'src/actions/customAttributes/customAttributesResource';

type RowActionProps = {
  item: CustomAttribute;
};

const RowActions: FC<RowActionProps> = ({ item }) => {
  const dispatch = useDispatch();

  const toggleCustomAttribute = () => {
    const toast = item.deactivated
      ? `'${item.label}' is now active.`
      : `'${item.label}' has been archived. Your freeform topics list just got a little lighter.`;

    const updatedItem = produce(item, draft => {
      draft.deactivated = !item.deactivated;
      draft._version = item._version + 1;
    });

    dispatch(
      customAttributesResource.effects.update({ id: item.id }, updatedItem, {
        customToastMsg: toast,
        disableWindowBack: true,
      })
    );
  };

  const confirmationText = item.deactivated ? `Activate '${item.label}'?` : `Archive '${item.label}'?`;
  const description = item.deactivated ? null : (
    <>
      Archiving a freeform topic may break certain functionality.{' '}
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://help.gladly.com/docs/archive-and-unarchive-freeform-topics"
      >
        Learn More
      </a>
    </>
  );
  const submitText = item.deactivated ? 'Activate Freeform Topic' : 'Archive Freeform Topic';
  return (
    <>
      <Archive
        confirmationText={confirmationText}
        description={description}
        submitText={submitText}
        itemId={item.id}
        onArchive={toggleCustomAttribute}
        isUnarchive={item.deactivated}
      />
      <Edit dataAid={`editLink-${item.id}`} id={item.id} />
    </>
  );
};

export default RowActions;
